import { render, staticRenderFns } from "./AlarmBreakingNews.vue?vue&type=template&id=cbe91462&scoped=true&"
import script from "./AlarmBreakingNews.vue?vue&type=script&lang=js&"
export * from "./AlarmBreakingNews.vue?vue&type=script&lang=js&"
import style0 from "./AlarmBreakingNews.vue?vue&type=style&index=0&id=cbe91462&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe91462",
  null
  
)

export default component.exports